module.exports = __webpack_public_path__ + "static/media/screenshot-6.5b137099.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/images/screenshot-6.png
// module id = 691
// module chunks = 2